/**
 * Client Model der Applikation. Wird über den ModelChangeService allen interessierten Komponenten zur Verfügung gestellt.
 */
import {GenericValue} from '@visana-web/basic-ui';

export class ClientModel {
  /**
   * searchResult, das generische Modell vom Server mit den Suchresultaten.
   */
  public searchResult?: GenericValue = undefined;

  /**
   * Die Suchkriterien zur aktuellen Suche
   */
  public searchCriteria?: GenericValue = undefined;

}
